module.exports = {
      id: "edit-usage",
      viewBox: "0 96 960 960",
      url: __webpack_public_path__ + "svg-sprite-505ff86a8b330a06721910bc2b8fe3a7.svg#edit",
      toString: function () {
        return this.url;
      }
    }